/*
  HW a11y 2026-09-23 (WCAG 2.1.1 Keyboard). At 990px and wider Horizon sets overflow: hidden on html and
  body and scrolls the page inside .page-wrapper, so Page Down, Space, the arrow keys, Home and End do
  nothing until focus is inside the page (Chromium, WebKit and Firefox alike). While nothing has focus, or
  focus is on the skip link that sits outside the wrapper, send those keys to the wrapper. Focused
  controls, modifier keys and open drawers or dialogs (html[scroll-lock]) are left to the browser.
*/
(() => {
  document.addEventListener('keydown', (event) => {
    if (event.defaultPrevented || event.altKey || event.ctrlKey || event.metaKey) return;
    const active = document.activeElement;
    const idle = !active || active === document.body || active === document.documentElement;
    if (!idle && !active.matches('.skip-to-content-link')) return;
    if (document.documentElement.hasAttribute('scroll-lock')) return;
    const wrapper = document.querySelector('.page-wrapper');
    if (!wrapper || getComputedStyle(wrapper).overflowY !== 'auto' || wrapper.scrollHeight <= wrapper.clientHeight) return;
    const page = Math.round(wrapper.clientHeight * 0.875);
    let by = 0;
    let to = null;
    switch (event.key) {
      case 'PageDown': by = page; break;
      case 'PageUp': by = -page; break;
      case ' ':
        if (!idle) return; // Space on the skip link is the link's own business
        by = event.shiftKey ? -page : page;
        break;
      case 'ArrowDown': by = 40; break;
      case 'ArrowUp': by = -40; break;
      case 'Home': to = 0; break;
      case 'End': to = wrapper.scrollHeight; break;
      default: return;
    }
    event.preventDefault();
    if (to === null) wrapper.scrollBy({ top: by });
    else wrapper.scrollTo({ top: to });
  });
})();
